export const LEGEND = 'LEGEND';
export const DROP = 'DROP';
export const PLACE = 'PLACE';
